import type { ReactElement } from "react";
import { Slot } from "@radix-ui/react-slot";
import { Camera, Images } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { canPickNativeMedia } from "../lib/native-media-picker";

/**
 * Wraps an attach button. In the iOS app it opens a small menu: the gallery
 * (native picker, so videos don't wait for iOS to convert them) or the system
 * chooser for the camera and Files. Everywhere else the button opens the
 * system chooser directly, as before.
 */
export function MediaAttachMenu({
  children,
  onGallery,
  onOtherFiles,
  disabled,
}: {
  children: ReactElement;
  onGallery: () => void;
  onOtherFiles: () => void;
  disabled?: boolean;
}) {
  if (!canPickNativeMedia()) {
    return <Slot onClick={disabled ? undefined : onOtherFiles}>{children}</Slot>;
  }
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild disabled={disabled}>
        {children}
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" side="top">
        <DropdownMenuItem onSelect={onGallery}>
          <Images className="mr-2 h-4 w-4" />
          Galerija
        </DropdownMenuItem>
        <DropdownMenuItem onSelect={onOtherFiles}>
          <Camera className="mr-2 h-4 w-4" />
          Kamera ili datoteke
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
